// École Nid Douillet - API Health Checker Component
// Monitors API connectivity and shows status

import React, { useState, useEffect } from 'react';
import { checkApiHealth } from '@services/api';
import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const ApiHealthChecker: React.FC = () => {
  const [isHealthy, setIsHealthy] = useState<boolean>(true);
  const [isChecking, setIsChecking] = useState<boolean>(false);
  const [lastCheck, setLastCheck] = useState<Date | null>(null);

  const checkHealth = async () => {
    setIsChecking(true);
    try {
      const healthy = await checkApiHealth();
      setIsHealthy(healthy);
      setLastCheck(new Date());
    } catch (error) {
      setIsHealthy(false);
      setLastCheck(new Date());
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    // Initial health check
    checkHealth();

    // Set up periodic health checks every 5 minutes
    const interval = setInterval(checkHealth, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Don't show anything if API is healthy
  if (isHealthy) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="flex items-center space-x-2 rounded-lg bg-red-50 p-3 shadow-lg border border-red-200">
        <ExclamationTriangleIcon className="h-5 w-5 text-red-500" />
        <div className="text-sm">
          <p className="font-medium text-red-800">
            Connexion API interrompue
          </p>
          <p className="text-red-600">
            Vérifiez votre connexion réseau
          </p>
        </div>
        <button
          onClick={checkHealth}
          disabled={isChecking}
          className="ml-2 rounded bg-red-100 px-2 py-1 text-xs font-medium text-red-800 hover:bg-red-200 disabled:opacity-50"
        >
          {isChecking ? 'Vérification...' : 'Réessayer'}
        </button>
      </div>
    </div>
  );
};

export default ApiHealthChecker;
